import { useAuthStateSuspenseQuery } from 'generated/graphql';
import {
  Navigate,
  Outlet
} from 'react-router-dom';



export type SuperAdminRouteProps = {
  // children: ReactNode | ReactNode[] | undefined;
};

export const FC = (props: SuperAdminRouteProps) => {
  const tuple = useAuthStateSuspenseQuery();
  if (tuple.data.loggedInUser?.person && !tuple.data?.loggedInUser?.person.isActive) {
    return (
      <Navigate to='/auth/login' />
    );
  }
  if (tuple.data?.loggedInUser?.isSuperAdmin) {
    return (
      <Outlet />
    );
  } else return (
    <Navigate to='/insights' replace={true} />
  );
};
